import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleCourseBlockComponent } from './components/single-course-block/single-course-block.component';
import { SingleConferenceBlockComponent } from './components/single-conference-block/single-conference-block.component';
import { SingleSeriesBlockComponent } from './components/single-series-block/single-series-block.component';
import { RouterModule } from '@angular/router';
import { QuestionBlockComponent } from './components/question-block/question-block.component';
import { SingleComponent } from './components/question-type/single/single.component';
import { MultipleChoiceComponent } from './components/question-type/multiple-choice/multiple-choice.component';
import { CertificateBlockComponent } from './components/certificate-block/certificate-block.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AgreeDisagreeComponent } from './components/question-type/agree-disagree/agree-disagree.component';
import { PoorExcellentComponent } from './components/question-type/poor-excellent/poor-excellent.component';
import { NeverAlwaysComponent } from './components/question-type/never-always/never-always.component';
import { SemanticAbilityComponent } from './components/question-type/semantic-ability/semantic-ability.component';
import { SemanticNeutralComponent } from './components/question-type/semantic-neutral/semantic-neutral.component';
import { PoorOutstandingComponent } from './components/question-type/poor-outstanding/poor-outstanding.component';
import { NoviceExpertComponent } from './components/question-type/novice-expert/novice-expert.component';
import { LikertScale1Component } from './components/question-type/likert-scale-1/likert-scale-1.component';
import { LikertScale2Component } from './components/question-type/likert-scale-2/likert-scale-2.component';
import { LikertScale3Component } from './components/question-type/likert-scale-3/likert-scale-3.component';
import { LikertScale4Component } from './components/question-type/likert-scale-4/likert-scale-4.component';
import { MultipleSelectComponent } from './components/question-type/multiple-select/multiple-select.component';
import { FormsModule } from '@angular/forms';
import { ChoiceWithOpinionComponent } from './components/question-type/choice-with-opinion/choice-with-opinion.component';
import { SemanticYesComponent } from './components/question-type/semantic-yes/semantic-yes.component';
import { ParentComponent } from './components/question-type/parent/parent.component';
import { SingleCourseCardComponent } from './components/single-course-card/single-course-card.component';
import { SingleCourseCardWideComponent } from './components/single-course-card-wide/single-course-card-wide.component';
import { SemanticHighComponent } from './components/question-type/semantic-high/semantic-high.component';
import { LoaderComponent } from './components/loader/loader.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SingleLiveBlockComponent } from './components/single-live-block/single-live-block.component';
import { SingleLiveCardComponent } from './components/single-live-card/single-live-card.component';
import { ActivityReturnComponent } from './components/activity-return/activity-return.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

import { SinglePushLiveCardComponent } from './components/single-push-live-card/single-push-live-card.component';
import { DisableQuestionBlockComponent } from './components/disable-question-block/disable-question-block.component';
import { DisableSingleComponent } from './components/disable-question-type/disable-single/disable-single.component';
import { DisableLikertScale1Component } from './components/disable-question-type/disable-likert-scale-1/disable-likert-scale-1.component';
import { DisableLikertScale2Component } from './components/disable-question-type/disable-likert-scale-2/disable-likert-scale-2.component';
import { DisableLikertScale3Component } from './components/disable-question-type/disable-likert-scale-3/disable-likert-scale-3.component';
import { DisableSemanticYesComponent } from './components/disable-question-type/disable-semantic-yes/disable-semantic-yes.component';
import { DisableAgreeDisagreeComponent } from './components/disable-question-type/disable-agree-disagree/disable-agree-disagree.component';
import { DisableChoiceWithOpinionComponent } from './components/disable-question-type/disable-choice-with-opinion/disable-choice-with-opinion.component';
import { DisableMultipleSelectComponent } from './components/disable-question-type/disable-multiple-select/disable-multiple-select.component';
import { DisableNeverAlwaysComponent } from './components/disable-question-type/disable-never-always/disable-never-always.component';
import { DisableNoviceExpertComponent } from './components/disable-question-type/disable-novice-expert/disable-novice-expert.component';
import { DisablePoorExcellentComponent } from './components/disable-question-type/disable-poor-excellent/disable-poor-excellent.component';
import { DisablePoorOutstandingComponent } from './components/disable-question-type/disable-poor-outstanding/disable-poor-outstanding.component';
import { DisableSemanticAbilityComponent } from './components/disable-question-type/disable-semantic-ability/disable-semantic-ability.component';
import { DisableSemanticHighComponent } from './components/disable-question-type/disable-semantic-high/disable-semantic-high.component';
import { DisableSemanticNeutralComponent } from './components/disable-question-type/disable-semantic-neutral/disable-semantic-neutral.component';
import { DisableMultipleChoiceComponent } from './components/disable-question-type/disable-multiple-choice/disable-multiple-choice.component';
import { DisableParentComponent } from './components/disable-question-type/disable-parent/disable-parent.component';
import { TimerComponent } from './components/timer/timer.component';
import { OnlyImageComponent } from './components/question-type/only-image/only-image.component';
import { WordCloudComponent } from './components/question-type/word-cloud/word-cloud.component';
import { OpenResponseComponent } from './components/question-type/open-response/open-response.component';
import { WordCloudDisplayComponent } from './components/word-cloud-display/word-cloud-display.component';

@NgModule({
  declarations: [
    SingleCourseBlockComponent,
    SingleConferenceBlockComponent,
    SingleSeriesBlockComponent,
    QuestionBlockComponent,
    SingleComponent,
    MultipleChoiceComponent,
    CertificateBlockComponent,
    AgreeDisagreeComponent,
    PoorExcellentComponent,
    NeverAlwaysComponent,
    SemanticAbilityComponent,
    SemanticNeutralComponent,
    PoorOutstandingComponent,
    NoviceExpertComponent,
    LikertScale1Component,
    LikertScale2Component,
    LikertScale3Component,
    LikertScale4Component,
    MultipleSelectComponent,
    ChoiceWithOpinionComponent,
    SemanticYesComponent,
    ParentComponent,
    SingleCourseCardComponent,
    SingleCourseCardWideComponent,
    SemanticHighComponent,
    LoaderComponent,
    NotFoundComponent,
    SingleLiveBlockComponent,
    SingleLiveCardComponent,
    SinglePushLiveCardComponent,

    DisableQuestionBlockComponent,
    DisableSingleComponent,
    DisableLikertScale1Component,
    DisableLikertScale2Component,
    DisableLikertScale3Component,
    DisableSemanticYesComponent,
    DisableAgreeDisagreeComponent,
    DisableChoiceWithOpinionComponent,
    DisableMultipleSelectComponent,
    DisableNeverAlwaysComponent,
    DisableNoviceExpertComponent,
    DisablePoorExcellentComponent,
    DisablePoorOutstandingComponent,
    DisableSemanticAbilityComponent,
    DisableSemanticHighComponent,
    DisableSemanticNeutralComponent,
    DisableMultipleChoiceComponent,
    DisableParentComponent,
    TimerComponent,
    OnlyImageComponent,
    WordCloudComponent,
    OpenResponseComponent,
    WordCloudDisplayComponent,
    ActivityReturnComponent,
    SafeHtmlPipe,
  ],
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule],
  exports: [
    SingleCourseBlockComponent,
    SingleCourseCardComponent,
    SingleLiveBlockComponent,
    SingleCourseCardWideComponent,
    SingleConferenceBlockComponent,
    SingleSeriesBlockComponent,
    SingleLiveCardComponent,
    QuestionBlockComponent,
    SingleComponent,
    MultipleChoiceComponent,
    CertificateBlockComponent,
    LoaderComponent,
    SinglePushLiveCardComponent,
    DisableQuestionBlockComponent,
    TimerComponent,
    OnlyImageComponent,
    WordCloudDisplayComponent,
    ActivityReturnComponent,
    SafeHtmlPipe,
  ],
})
export class SharedModule {}
